"use strict";
/**
 * Weekly Report V2 — Report Types
 *
 * Input/output types for report mode determination, section availability,
 * and variant determination services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=report.js.map